module.exports = __webpack_public_path__ + "static/media/arriving.b5f7e43b.svg";